import { render, staticRenderFns } from "./ImageNotice.vue?vue&type=template&id=5a307893&scoped=true&"
import script from "./ImageNotice.vue?vue&type=script&lang=js&"
export * from "./ImageNotice.vue?vue&type=script&lang=js&"
import style0 from "./ImageNotice.vue?vue&type=style&index=0&id=5a307893&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a307893",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a307893')) {
      api.createRecord('5a307893', component.options)
    } else {
      api.reload('5a307893', component.options)
    }
    module.hot.accept("./ImageNotice.vue?vue&type=template&id=5a307893&scoped=true&", function () {
      api.rerender('5a307893', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ImageNotice.vue"
export default component.exports